import React, { useState, useEffect, useContext } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { useWindowSize } from 'react-use'

// apis
import { fetchSalesAccountsReceivable } from '@/apis/aipass'

// components
import { SettingSalesManagerTab } from '@/components/organisms/settings/sales-manager/tab'

// models
import { AccountsReceivableSettingType } from '@/models/accounts-receivable'
import { SettingsLayout } from '@/components/layouts/settings-layout'
import { TabContainer } from '@/components/organisms/settings/tab-container'
import { SettingReceivableList } from '@/components/organisms/settings/sales-manager/accounts-receivable/list'
import { Button } from '@/components/atoms'
import { ButtonType } from '@/components/atoms/button'
import { AccountContext } from '@/contexts/account'
import { isScreenReadOnlyForUi } from '@/libs/hotel-pms-permission'

type ContainerProps = {}

export const SettingSalesManagerAccountsReceivable: React.FC<ContainerProps> = () => {
  const { t } = useTranslation()
  const { permissions, permissionsLoaded, permissionsError } = useContext<any>(AccountContext)
  const isSettingsReadOnly = isScreenReadOnlyForUi(permissions, 'settings', permissionsLoaded, permissionsError)
  const history = useHistory()
  const location = useLocation()

  const [accountsReceivableSettings, setAccountsReceivableSettings] = useState<AccountsReceivableSettingType[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const _fetchSalesAccountsReceivable = async () => {
    setIsLoading(true)
    await fetchSalesAccountsReceivable()
      .then(res => {
        setAccountsReceivableSettings(res?.accountsReceivables)
      })
      .catch(() => {
        console.log(t('Communication failed'))
      })
    setIsLoading(false)
  }

  useEffect(() => {
    _fetchSalesAccountsReceivable()
  }, [])

  const windows = useWindowSize()
  return (
    <SettingsLayout loading={isLoading}>
      <TabContainer tabComponent={<SettingSalesManagerTab currentTab="Accounts receivable" />}>
        <div
          css={settingListContainerStyle}
          style={{
            maxHeight: windows.height - 148,
          }}
        >
          <div css={editButtonWrapperStyle}>
            <Button
              buttonType={isSettingsReadOnly ? ButtonType.PrimaryDisabled : ButtonType.Secondary}
              isDisabled={isSettingsReadOnly}
              onClick={() => {
                if (isSettingsReadOnly) {
                  alert(t('HotelPms.Error.readOnly'))
                  return
                }
                history.push({ pathname: '/setting/sales-manager/accounts-receivable/edit', search: location.search })
              }}
              width={75}
              height={32}
              fontSize={12}
            >
              {t('Edit')}
            </Button>
          </div>
          <SettingReceivableList accountsReceivables={accountsReceivableSettings} />
        </div>
      </TabContainer>
    </SettingsLayout>
  )
}

const settingListContainerStyle = css({
  boxShadow: '0px 0px 6px #0000001A',
  borderRadius: '0 5px 5px 5px',
  background: '#FFF',
  position: 'relative',
})

const editButtonWrapperStyle = css({
  display: 'flex',
  justifyContent: 'flex-end',
  padding: '24px 32px 34px',
})
